import { Plane, CalendarPlus } from "lucide-react";
import FlightActionButtons from "./FlightActionButtons";
import { FlightDetails } from "@/types/trip";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { trackTripCardAction } from "@/utils/analytics";
import { useState, useEffect } from "react";
import ETicketButton from "../ETicketButton";

interface FlightHeaderProps {
  flightDetails: FlightDetails;
  isWithin72Hours: boolean;
  isWithin48Hours: boolean;
  checkinUrl: string | { url: string; windowOpen: boolean; hoursUntilOpen: number } | null | undefined;
  onAddToCalendar?: (e: React.MouseEvent) => void;
  tripId: string;
  destinationName: string;
  showAddToCalendarButton?: boolean;
  hideStatusButton?: boolean;
}

const FlightHeader = ({
  flightDetails,
  isWithin72Hours,
  isWithin48Hours,
  checkinUrl,
  onAddToCalendar,
  tripId,
  destinationName,
  showAddToCalendarButton = true,
  hideStatusButton = true
}: FlightHeaderProps) => {
  const { t } = useTranslation();
  
  // Debug logging for confirmation numbers
  useEffect(() => {
    console.debug('FlightHeader - Flight details:', flightDetails);
    console.debug('FlightHeader - Confirmation numbers:', flightDetails.confirmationNumbers);
  }, [flightDetails]);
  
  const handleAddToCalendar = (e: React.MouseEvent) => {
    if (onAddToCalendar) {
      e.stopPropagation(); // Prevent event bubbling
      trackTripCardAction("add_to_calendar", tripId, destinationName);
      onAddToCalendar(e);
    }
  };
  
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-travel-600">
          <Plane className="w-4 h-4" />
          <span className="font-semibold text-sm">
            {flightDetails.airline} {flightDetails.flightNumber}
          </span>
          {flightDetails.operating && flightDetails.operating.airline && flightDetails.operating.airline != flightDetails.airline && (
            <span className="text-xs text-gray-500">
              (Operated by {flightDetails.operating.airline})
            </span>
          )}
        </div>
        
        <div className="flex gap-2">
          {/* Use the dedicated ETicketButton component */}
          <ETicketButton 
            confirmationNumbers={flightDetails.confirmationNumbers}
            flightNumber={flightDetails.flightNumber}
            tripId={tripId}
            destinationName={destinationName}
          />
          
          <FlightActionButtons
            flightNumber={flightDetails.flightNumber}
            isWithin72Hours={isWithin72Hours}
            isWithin48Hours={isWithin48Hours}
            checkinUrl={checkinUrl}
            tripId={tripId}
            destinationName={destinationName}
            departureDate={flightDetails.departure.time}
            departureCode={flightDetails.departure.code}
            arrivalCode={flightDetails.arrival.code}
          />
          
          {/* Status button removed as requested */}
        </div>
      </div>
      
      {/* Add to Calendar Button - removed for flights as requested */}
    </div>
  );
};

export default FlightHeader;
